import { apiClient } from './apiClient';

export const warehouseService = {
  // Get all warehouses
  async getWarehouses() {
    return apiClient.get(`/api/cmms/warehouses`);
  },

  // Get warehouses by branch
  async getWarehousesByBranch(branchId) {
    return apiClient.get(`/api/cmms/warehouses/branch/${branchId}`);
  },

  // Get active warehouses only
  async getActiveWarehouses() {
    return apiClient.get(`/api/cmms/warehouses/active`);
  },

  // Get single warehouse by ID
  async getWarehouseById(id) {
    return apiClient.get(`/api/cmms/warehouses/${id}`);
  },

  // Create new warehouse
  async createWarehouse(data) {
    // Transform frontend form data to match backend DTO
    const payload = {
      code: data.code,
      name: data.name,
      branchId: data.branchId ? parseInt(data.branchId) : null,
      warehouseType: data.warehouseType,
      status: data.status || 'ACTIVE',
      description: data.description || null,
      capacity: data.capacity ? parseInt(data.capacity) : null,
      capacityUnit: data.capacityUnit || null,
      currentUtilization: data.currentUtilization ? parseInt(data.currentUtilization) : null,
      managerName: data.managerName || null,
      managerEmail: data.managerEmail || null,
      managerPhone: data.managerPhone || null,
      notes: data.notes || null
    };
    return apiClient.post(`/api/cmms/warehouses`, payload);
  },

  // Update warehouse
  async updateWarehouse(id, data) {
    // Transform frontend form data to match backend DTO
    const payload = {
      code: data.code,
      name: data.name,
      branchId: data.branchId ? parseInt(data.branchId) : null,
      warehouseType: data.warehouseType,
      status: data.status || 'ACTIVE',
      description: data.description || null,
      capacity: data.capacity ? parseInt(data.capacity) : null,
      capacityUnit: data.capacityUnit || null,
      currentUtilization: data.currentUtilization ? parseInt(data.currentUtilization) : null,
      managerName: data.managerName || null,
      managerEmail: data.managerEmail || null,
      managerPhone: data.managerPhone || null,
      notes: data.notes || null
    };
    return apiClient.put(`/api/cmms/warehouses/${id}`, payload);
  },

  // Delete warehouse
  async deleteWarehouse(id) {
    return apiClient.delete(`/api/cmms/warehouses/${id}`);
  },
};
